import React from "react";
import Button, {ButtonProps} from "@mui/material/Button";
import {styled} from "@mui/material/styles";

const RoundedButton = styled(Button)<ButtonProps>((theme) => ({
    borderRadius: '20px',
}))

export default RoundedButton;